import { Controller, useFormContext, useFormState } from 'react-hook-form';

import { ErrorMessage } from './ErrorMessage';
import { InputLabel } from '../ui/InputLabel';
import MaskedInput from '../ui/MaskedInput';

interface IProps {
  id: string;
  name: string;
  placeholder?: string;
  label?: string;
  prefix?: string;
}

export const MoneyInputMask = ({ id, name, placeholder, prefix, label }: IProps) => {
  const { control } = useFormContext();
  const { errors } = useFormState({ control });

  const message = errors[name]?.message as string | undefined;

  return (
    <div>
      <InputLabel>{label}</InputLabel>
      <Controller
        control={control}
        name={name}
        rules={{ required: true }}
        render={({ field }) => (
          <MaskedInput
            id={id}
            mask='money'
            type='number'
            prefix={prefix}
            placeholder={placeholder}
            message={message ? 'error' : ''}
            {...field}
          />
        )}
      />
      <ErrorMessage fieldName={name} />
    </div>
  );
};
